import ClozeAnswer from './clozeanswer/ClozeAnswer'
import FreeAnswer from './freeanswer/FreeAnswer'
import MatrixSortAnswer from './matrixsortanswer/MatrixSortAnswer'
import SingleAnswer from './single/SingleAnswer'
import SortAnswer from './sortanswer/SortAnswer'

const Answer = ({ ...props }) => {

    const answerType = props.answerType 
    const answerChoices = props.answerChoices
    const userAnswer = props.userAnswer
    const info = props.info

    const renderAnswer = () => {
        const components = {
            single: SingleAnswer,
            multiple: SingleAnswer,
            free_answer: FreeAnswer,
            sort_answer: SortAnswer,
            matrix_sort_answer: MatrixSortAnswer,
            cloze_answer: ClozeAnswer
        }
    
        const Component = components[answerType]
        return Component ? <Component answerChoices={answerChoices} userAnswer={userAnswer} info={info} /> : ""
    };
  
    return (
        <div className='msync-question-container__answer'>
            { renderAnswer() }
        </div>
    )
}

export default Answer